import React,{useEffect,useState} from 'react';
import {auth,db} from '../../firebase/firebase.js';
import {doc,getDoc,collection,getDocs} from 'firebase/firestore';
import '../../styles/ResellerAnalytics.css';

export default function ResellerAnalytics(){
  const [resellerId,setResellerId] = useState('');
  const [stats,setStats] = useState({
    totalClients:0,
    totalLeads:0,
    totalQuotes:0,
    totalDrivers:0
  });
  const [loading,setLoading] = useState(true);

  useEffect(()=>{
    const user = auth.currentUser;
    if(!user) return;
    loadReseller(user.uid);
  },[]);

  const loadReseller = async(uid)=>{
    const userRef = doc(db,'users',uid);
    const snap = await getDoc(userRef);
    if(!snap.exists()) return;

    const data = snap.data();
    if(!data.resellerId) return;

    setResellerId(data.resellerId);
    loadAnalytics(data.resellerId);
  };

  const loadAnalytics = async(rid)=>{
    const clientsRef = collection(db,'resellers',rid,'clients');
    const clientSnap = await getDocs(clientsRef);

    let totalLeads=0;
    let totalQuotes=0;
    let totalDrivers=0;

    for(const c of clientSnap.docs){
      const bid = c.id;

      const leadsSnap = await getDocs(collection(db,'businesses',bid,'leads'));
      const quotesSnap = await getDocs(collection(db,'businesses',bid,'quotes'));
      const driversSnap = await getDocs(collection(db,'businesses',bid,'drivers'));

      totalLeads += Math.max(0, leadsSnap.size - 1); // ignore _init
      totalQuotes += Math.max(0, quotesSnap.size - 1);
      totalDrivers += Math.max(0, driversSnap.size - 1);
    }

    setStats({
      totalClients: clientSnap.size,
      totalLeads,
      totalQuotes,
      totalDrivers
    });

    setLoading(false);
  };

  if(loading){
    return <div className="dashboard-container"><h2>Loading Analytics...</h2></div>;
  }

  return(
    <div className="dashboard-container">
      <h2>Reseller Analytics</h2>

      <div className="analytics-grid">

        <div className="analytics-card">
          <p>Total Clients</p>
          <h3>{stats.totalClients}</h3>
        </div>

        <div className="analytics-card">
          <p>Total Leads</p>
          <h3>{stats.totalLeads}</h3>
        </div>

        <div className="analytics-card">
          <p>Total Quotes</p>
          <h3>{stats.totalQuotes}</h3>
        </div>

        <div className="analytics-card">
          <p>Total Drivers</p>
          <h3>{stats.totalDrivers}</h3>
        </div>

      </div>

    </div>
  );
}
